"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPayPopupActivity = addPayPopupActivity;
exports.delPayPopupActivity = delPayPopupActivity;
exports.queryPayPopupActivity = queryPayPopupActivity;
exports.queryPayPopupActivityPage = queryPayPopupActivityPage;
exports.updatePayPopupActivity = updatePayPopupActivity;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var request_api_prefix = '/xyPayPopupActivity';

/**
 * 分页查询弹窗活动
 * @param params 查询参数
 */
function queryPayPopupActivityPage(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/page',
    method: 'get',
    params: params
  });
}

/**
 * 弹窗活动明细
 * @param id 活动ID
 */
function queryPayPopupActivity(id) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/' + id,
    method: 'get'
  });
}

/**
 * 新增弹窗活动
 * @param data 活动数据
 */
function addPayPopupActivity(data) {
  return (0, _requestPIM.default)({
    url: request_api_prefix,
    method: 'post',
    data: data
  });
}

/**
 * 修改弹窗活动
 * @param data 活动数据（含 id）
 */
function updatePayPopupActivity(data) {
  return (0, _requestPIM.default)({
    url: request_api_prefix,
    method: 'put',
    data: data
  });
}

/**
 * 删除弹窗活动
 * @param id 活动ID
 */
function delPayPopupActivity(id) {
  return (0, _requestPIM.default)({
    url: request_api_prefix,
    method: 'delete',
    params: {
      id: id
    }
  });
}